import api from '@/api'
import i18n from '@Lang'
import FormatDate from './format-date'
import moment from 'moment'
import { ceil, toString, defaultTo, isFinite } from 'lodash'

export const formatTime = (time, type) => {
  const dateTime = new Date(time)
  const year = dateTime.getFullYear()
  const month = dateTime.getMonth() + 1
  const date = dateTime.getDate()
  const hour = dateTime.getHours()
  const minute = dateTime.getMinutes()
  const second = dateTime.getSeconds()
  if (type === 'hour') {
    return `${year}-${addZero(month)}-${addZero(date)} ${addZero(hour)}:${addZero(minute)}:${addZero(second)}`
  } else {
    return `${year}-${addZero(month)}-${addZero(date)}`
  }
  function addZero(v) {
    return v < 10 ? '0' + v : v
  }
}

// 获取时间区间范围的所有 date 天
export const getDateStrs = (start, end) => {
  const startTime = new Date(start)
  const endTime = new Date(end)
  const dateArr = []
  while (endTime.getTime() - startTime.getTime() >= 0) {
    const year = startTime.getFullYear()
    const month =
      (startTime.getMonth() + 1).toString().length === 1 ? '0' + (parseInt(startTime.getMonth().toString(), 10) + 1) : startTime.getMonth() + 1
    const day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate()
    dateArr.push(`${year}-${month}-${day}`)
    startTime.setDate(startTime.getDate() + 1)
  }
  return dateArr
}

// 获取时间区间范围的所有 month
export const getMonthStrs = (start, end) => {
  const startTime = new Date(start)
  startTime.setDate(1)
  const endTime = new Date(end)
  const arr = []
  while (endTime.getTime() - startTime.getTime() >= 0) {
    const year = startTime.getFullYear()
    const month =
      (startTime.getMonth() + 1).toString().length === 1 ? '0' + (parseInt(startTime.getMonth().toString(), 10) + 1) : startTime.getMonth() + 1
    // const day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate()
    arr.push(`${year}-${month}`)
    startTime.setMonth(startTime.getMonth() + 1)
  }
  return arr
}

// 获取时间区间范围的所有 hour
export const getHourStrs = (start, end) => {
  const now = new Date()
  const startTime = new Date(start)
  const endTime = new Date(end)
  startTime.setHours(0, 0, 0, 0)
  if (now.getTime() > (endTime.getTime() + 24 * 60 * 60 * 1000)) {
    endTime.setHours(23, 59, 59, 999)
  } else {
    endTime.setHours(now.getHours(), now.getMinutes(), now.getSeconds())
  }
  const hourArr = []
  while (endTime.getTime() - startTime.getTime() >= 0) {
    const year = startTime.getFullYear()
    const month =
      (startTime.getMonth() + 1).toString().length === 1 ? '0' + (parseInt(startTime.getMonth().toString(), 10) + 1) : startTime.getMonth() + 1
    const day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate()
    const hour = startTime.getHours().toString().length === 1 ? '0' + startTime.getHours() : startTime.getHours()
    hourArr.push(`${year}-${month}-${day} ${hour}:00`)
    startTime.setHours(startTime.getHours() + 1)
  }
  return hourArr
}

const formatYear = (start, startVal, endVal, len) => {
  const arr = []
  const yearStart = new Date(start).getDay() // 获取周几
  let initYearStart = yearStart // 将周几重新赋值
  let initStart = '' // 用来接收起始时间为周日的明天，也就是下周一个的日期
  for (let i = 0; i < len; i++) {
    let next_monday = ''; let next_sunday = ''
    if (yearStart !== 0) { // 不等于0表示起始时间不是周日， 正常计算即可
      next_monday = i === 0 ? startVal : moment(start).add((7 - yearStart) + 7 * (i - 1) + 1, 'd').format('YYYY-MM-DD')
      next_sunday = i === len - 1 ? endVal : moment(start).add((7 - yearStart) + 7 * i, 'd').format('YYYY-MM-DD')
    } else { // else中表示起始时间是周日
      if (initYearStart === 0) { // 周日为0 表示起始时间和截止时间是同一天
        next_monday = next_sunday = startVal
        initYearStart = 1 // 重新赋值为1 表示以后的从周一开始
        initStart = moment(start).add(1, 'd').format('YYYY-MM-DD')
        start = moment(initStart)
      } else {
        next_monday = i === 1 ? initStart : moment(start).add((7 - initYearStart) + 7 * (i - 2) + 1, 'd').format('YYYY-MM-DD')
        next_sunday = i === len - 1 ? endVal : moment(start).add((7 - initYearStart) + 7 * (i - 1), 'd').format('YYYY-MM-DD')
      }
    }
    const date = `${next_monday}~${next_sunday}` // 这个函数在上面有写
    arr.push(date)
  }
  return arr
}

export const getWeekStrs = (start, end) => {
  const beginTime = new Date(start)
  const endTime = new Date(end)

  // 开始时间
  const bY = beginTime.getFullYear()
  let bM = beginTime.getMonth() + 1
  bM = bM >= 10 ? bM : '0' + bM
  let bD = beginTime.getDate()
  bD = bD >= 10 ? bD : '0' + bD

  // 结束时间
  const eY = endTime.getFullYear()
  let eM = endTime.getMonth() + 1
  eM = eM >= 10 ? eM : '0' + eM
  let eD = endTime.getDate()
  eD = eD >= 10 ? eD : '0' + eD

  let arr = []
  let nowDiff = 0
  let futureWeek = 0
  if (bY !== eY) {
    const yearWeek = moment(`${bY}`).weeksInYear()
    const nowWeek = moment(`${bY}-${bM}-${bD}`).week()
    nowDiff = yearWeek - nowWeek
    futureWeek = moment(`${eY}-${eM}-${eD}`).week()
  } else {
    const diff = moment(`${eY}/${eM}/${eD}`).week() - moment(`${bY}-${bM}-${bD}`).week()
    if (beginTime.getDay() === 0 && endTime.getDay() !== 0) {
      nowDiff = diff + 2
    } else if (beginTime.getDay() !== 0 && endTime.getDay() === 0) {
      nowDiff = diff
    } else {
      nowDiff = diff + 1
    }
    futureWeek = 0
  }
  arr = formatYear(`${bY}-${bM}-${bD}`, `${bY}-${bM}-${bD}`, `${bY}-${eM}-${eD}`, nowDiff + futureWeek)
  return arr
}

// 初始化渠道列表
export const initChannels = async(appKey) => {
  const res = await api.businessChannel.businessChannel.listByAppKey(appKey)
  return res.data
}

// 渠道名称
export const getChannelName = (channels, channel = '') => {
  const obj = channels.find((o) => {
    return o.businessChannel === channel
  })
  if (obj) {
    return channel + '  (' + obj.businessChannelName + ')'
  } else {
    return channel
  }
}

export const clone = (obj) => {
  let o
  if (typeof obj === 'object') {
    if (obj === null) {
      o = null
    } else {
      if (obj instanceof Array) {
        o = []
        for (let i = 0, len = obj.length; i < len; i++) {
          o.push(clone(obj[i]))
        }
      } else {
        o = {}
        for (var j in obj) {
          o[j] = clone(obj[j])
        }
      }
    }
  } else {
    o = obj
  }
  return o
}

export function getMetaIndicators() {
  const indicators = [
    {
      value: 'Total',
      label: i18n.t('analysis.totalTimes')
    },
    {
      value: 'UserAmount',
      label: i18n.t('analysis.userNumber')
    }
  ]
  return indicators
}

export function getAttributionIndicators() {
  const indicators = [
    {
      value: 'PV',
      label: i18n.t('analysis.totalTimes')
    }
  ]
  return indicators
}

export function getChannelIndicators() {
  const indicators = [
    {
      value: 'PV',
      label: i18n.t('analysis.totalTimes')
    },
    {
      value: 'UV',
      label: i18n.t('analysis.userNumber')
    }
  ]
  return indicators
}

export function getGroupUserIndicators() {
  const indicators = [
    {
      value: 'total',
      label: i18n.t('public.allTimes')
    },
    {
      value: 'distribution',
      label: i18n.t('public.distribute')
    },
    {
      value: 'time',
      label: i18n.t('public.stayTime'),
      children: [
        {
          value: 'total',
          label: i18n.t('public.sum')
        },
        {
          value: 'avg',
          label: i18n.t('public.average')
        },
        {
          value: 'max',
          label: i18n.t('public.max')
        },
        {
          value: 'min',
          label: i18n.t('public.min')
        }
      ]
    }
  ]
  return indicators
}

export function customIndicators() {
  const indicators = [
    {
      label: 'PV(访问量)',
      value: 'PV'
    },
    {
      label: 'UV(访客数)',
      value: 'UV'
    }
  ]
  return indicators
}

export function distributionIndicators() {
  const indicators = [
    {
      label: i18n.t('public.visitTimes'),
      value: 'pv'
    },
    {
      label: i18n.t('public.dayNumber'),
      value: 'day'
    },
    {
      label: i18n.t('public.hourNumber'),
      value: 'hour'
    },
    {
      label: `${i18n.t('public.stayTime')}(S)`,
      value: 'time',
      children: [
        {
          value: 'total',
          label: i18n.t('public.sum')
        },
        {
          value: 'avg',
          label: i18n.t('public.average')
        },
        {
          value: 'max',
          label: i18n.t('public.max')
        },
        {
          value: 'min',
          label: i18n.t('public.min')
        },
        {
          value: 'dedup',
          label: i18n.t('public.deduplication')
        }
      ]
    }
  ]
  return indicators
}

export function getAppPlatform(appPlatform) {
  switch (appPlatform) {
    case 'WeApp':
      return '微信小程序'
    case 'H5':
      return 'H5'
    case 'AlipayApp':
      return '支付宝小程序'
    case 'BaiduApp':
      return '百度小程序'
    case 'android':
      return 'Android'
    case 'ios':
      return 'ios'
    case 'headlineApp':
      return '头条应用'
  }
}

export const toThousands = (s, n = 2) => {
  if (!s) { return '0' }
  n = n > 0 && n <= 20 ? n : 2
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
  var l = s.split('.')[0].split('').reverse()
  var r = s.split('.')[1]
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
  }
  let result = t.split('').reverse().join('') + '.' + r
  if (n === 2) {
    if (result.split('.')[1] === '00') {
      result = result.split('.')[0]
    }
  }
  return result
}

export const toThousandsInt = (s, n) => {
  n = n > 0 && n <= 20 ? n : 2
  s = parseFloat((s + '').replace(/[^\d.-]/g, '')).toFixed(n) + ''
  const l = s.split('.')[0].split('').reverse()
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '')
  }
  return t.split('').reverse().join('')
}

export const getWeekInYear = (t1, t2) => {
  const time1 = new Date(t1)
  const time2 = new Date(t2)
  const day = parseInt((time2.getTime() - time1.getTime()) / (1000 * 60 * 60 * 24))
  const curWeekDay = time1.getDay() === 0 ? 0 : 7 - time1.getDay()
  return Math.ceil((day - curWeekDay) / 7)
}

export const getMonths = (t1, t2) => {
  t1 = FormatDate.format(t1, 'yyyy-MM')
  t2 = FormatDate.format(t2, 'yyyy-MM')
  t1 = t1.split('-')
  t2 = t2.split('-')
  const year1 = parseInt(t1[0])
  const month1 = parseInt(t1[1])
  const year2 = parseInt(t2[0])
  const month2 = parseInt(t2[1])
  return (year2 - year1) * 12 + (month2 - month1)
}

export const fixUploadParams = (obj) => {
  let params = ''
  for (const o in obj) {
    params = `${params}${o}=${obj[o]}&`
  }
  return params.substring(0, params.lastIndexOf('&'))
}

export function getTabelLabel(item) {
  const TexT = {
    分组: i18n.t('analysis.group'),
    指标: i18n.t('analysis.indicator'),
    事件: i18n.t('analysis.event'),
    总次数: i18n.t('analysis.totalTimes'),
    用户数: i18n.t('analysis.userNumber'),
    用户行数: i18n.t('system.numberOfUsers'),
    日志行数: i18n.t('system.numberOfLog')
  }
  return TexT[item] || ''
}
/**
 * 向上取整 并且保持千分位
 * @param {*} num 数字
 * @param {*} decimal 保留小数位数
 * @returns
 */
export function getPlace(num, decimal = 2) {
  const reg = /(?=\B(\d{3})+$)/g
  const isNumber = isFinite(Number(num))
  const floatingPoint = toString(defaultTo(ceil(Number(num), decimal), num))
  const n = floatingPoint.split('.')
  return isNumber ? `${n[0].replace(reg, ',')}${n[1] ? `.${n[1]}` : ''}` : num
}
